/** Kannada: moving to a new city through Talk. */
export const moving = {
    "moving.suggest": "ಹೊಸ ಊರಿಗೆ ಹೋಗುತ್ತಿದ್ದೀರಾ?",
    "moving.no_figures": "{trade}: ಈ ನಗರಕ್ಕೆ ಇನ್ನೂ ಸಂಬಳದ ಅಂಕಿಗಳಿಲ್ಲ.",
    "moving.no_outlook": "ಆ ನಗರಕ್ಕೆ ನನ್ನ ಬಳಿ ಇನ್ನೂ ಸಂಬಳದ ಅಂಕಿಗಳಿಲ್ಲ.",
    "moving.listed.one": "GigSync ನಲ್ಲಿ {city}ನ {count} ಕೆಲಸಗಾರರು {trade} ಕೆಲಸ ಮಾಡುತ್ತಾರೆ.",
    "moving.listed.other": "GigSync ನಲ್ಲಿ {city}ನ {count} ಕೆಲಸಗಾರರು {trade} ಕೆಲಸ ಮಾಡುತ್ತಾರೆ.",
    "moving.listed_many": "GigSync ನಲ್ಲಿ {city}ನ {count} ಅಥವಾ ಹೆಚ್ಚು ಕೆಲಸಗಾರರು {trade} ಕೆಲಸ ಮಾಡುತ್ತಾರೆ.",
    "moving.estimates": "ಈ ಅಂಕಿಗಳು ಸಾರ್ವಜನಿಕ ಮೂಲಗಳಿಂದ ಅಂದಾಜು, ಸಂಬಳದ ಭರವಸೆ ಅಲ್ಲ.",
    "moving.figures": "ಅಂಕಿಗಳು",
    "moving.which_work": "ನೀವು ಯಾವ ಕೆಲಸ ಮಾಡುತ್ತೀರಿ? ಆಗ ಅಲ್ಲಿನ ಸಾಮಾನ್ಯ ಸಂಬಳ ಹೇಳುತ್ತೇನೆ.",
    "moving.first": "{city}ನಲ್ಲಿ ಮೊದಲು ಇವುಗಳನ್ನು ಮಾಡಿ:",
    "moving.no_guide": "ಆ ನಗರದ ಮಾರ್ಗದರ್ಶಿ ನನ್ನ ಬಳಿ ಇನ್ನೂ ಇಲ್ಲ. ಸದ್ಯಕ್ಕೆ ಬೆಂಗಳೂರಿನದು ಮಾತ್ರ ಇದೆ.",
    "moving.general": "ಯಾವ ಊರಿನಲ್ಲೂ ನೆರವಾಗುವುದು:",
    "moving.lines": "ಭಾರತದ ಎಲ್ಲೆಡೆ ಕೆಲಸ ಮಾಡುವ ಸಂಖ್ಯೆಗಳು:",
    "moving.line.emergency": "ತುರ್ತು: ಪೊಲೀಸ್, ಅಗ್ನಿಶಾಮಕ, ಆಂಬುಲೆನ್ಸ್",
    "moving.line.women": "ಮಹಿಳಾ ಸಹಾಯವಾಣಿ",
    "moving.line.eshram": "ಇ-ಶ್ರಮ್ ಸಹಾಯ ಕೇಂದ್ರ",
    "moving.line.cyber": "ಸೈಬರ್ ಅಪರಾಧ ಮತ್ತು ಆನ್‌ಲೈನ್ ಹಣದ ವಂಚನೆ",
    "moving.line.legal": "ಉಚಿತ ಕಾನೂನು ನೆರವು (NALSA)",
    "moving.stay": "ಎಲ್ಲಿ ಉಳಿಯುವುದು",
    "moving.documents": "ದಾಖಲೆಗಳು",
    "moving.find": "ಊರು ಗೊತ್ತಿರುವವರನ್ನು ಹುಡುಕಿ",
    "moving.checklist": "ನನ್ನ ಸ್ಥಳಾಂತರದ ಪಟ್ಟಿ",
    "moving.places": "ಮಾರ್ಗದರ್ಶಿಯಲ್ಲಿರುವ ಉಳಿಯುವ ಜಾಗಗಳು ({count})",
    "moving.documents_lead": "ದಾಖಲೆಗಳ ಬಗ್ಗೆ ಮಾರ್ಗದರ್ಶಿ ಹೇಳುವುದು. ಓದಲು ಒಂದನ್ನು ಟ್ಯಾಪ್ ಮಾಡಿ.",
    "moving.no_answer": "ಮಾರ್ಗದರ್ಶಿಯಲ್ಲಿ ಇದರ ಬಗ್ಗೆ ಇನ್ನೂ ಏನೂ ಇಲ್ಲ. ಊರು ಗೊತ್ತಿರುವವರನ್ನು ಕೇಳಿ, ಅಥವಾ ಸಹಾಯವಾಣಿಗೆ ಕರೆ ಮಾಡಿ.",
    "moving.found": "{city} ಗೊತ್ತಿರುವವರು, ಅವರೇ ಎಣಿಸಿದ ಕೆಲಸಗಳೊಂದಿಗೆ. ಒಬ್ಬರನ್ನು ಕೇಳಿ, ಅವರು ಹೌದು ಅಥವಾ ಇಲ್ಲ ಎನ್ನಬಹುದು.",
    "moving.none": "{city} ಗೊತ್ತಿರುವ ಯಾರೂ ಇನ್ನೂ ಹೊಂದುತ್ತಿಲ್ಲ.",
    "moving.more_ways": "ಯಾರನ್ನಾದರೂ ಹುಡುಕುವ ಇನ್ನಷ್ಟು ದಾರಿಗಳು",
    "moving.ask": "{name} ಅವರನ್ನು ಕೇಳಿ",
    "moving.arrive": "ನೀವು {city}ಗೆ ಯಾವಾಗ ಬರುತ್ತೀರಿ?",
    "moving.arrive_0": "ಈ ವಾರ",
    "moving.arrive_1": "ಮುಂದಿನ ವಾರ",
    "moving.arrive_2": "ಎರಡು ವಾರದಲ್ಲಿ",
    "moving.sent": "{name} ಅವರನ್ನು ಕೇಳಲಾಗಿದೆ. ಅವರ ಉತ್ತರ Today ನಲ್ಲಿ ಕಾಣುತ್ತದೆ.",
    "moving.not_eligible": "GigSync ನಲ್ಲಿ {min_months} ತಿಂಗಳು ಮತ್ತು {min_jobs} ಮುಗಿದ ಕೆಲಸಗಳ ನಂತರ ನೀವು ಹೊಸಬರಿಗೆ ಸಹಾಯ ಮಾಡಬಹುದು. ನಿಮ್ಮ ಫೋನ್ {months} ತಿಂಗಳಲ್ಲಿ {jobs} ಕೆಲಸಗಳನ್ನು ಎಣಿಸಿದೆ.",
    "moving.list_area": "{city}ನ ಯಾವ ಪ್ರದೇಶ ನಿಮಗೆ ಚೆನ್ನಾಗಿ ಗೊತ್ತು?",
    "moving.list_trades": "ಯಾವ ಕೆಲಸದ ಬಗ್ಗೆ ಹೊಸಬರಿಗೆ ಹೇಳಬಲ್ಲಿರಿ? ಪ್ರತಿಯೊಂದನ್ನು ಟ್ಯಾಪ್ ಮಾಡಿ, ನಂತರ ಆಯಿತು.",
    "moving.list_languages": "ನೀವು ಯಾವ ಭಾಷೆಗಳನ್ನು ಮಾತಾಡುತ್ತೀರಿ? ಪ್ರತಿಯೊಂದನ್ನು ಟ್ಯಾಪ್ ಮಾಡಿ, ನಂತರ ಆಯಿತು.",
    "moving.list_woman": "ನೀವು ಮಹಿಳೆಯೇ? ಮಹಿಳಾ ಮಾರ್ಗದರ್ಶಕರನ್ನು ಕೇಳುವ ಮಹಿಳೆಯರು ನಿಮ್ಮನ್ನು ಹುಡುಕಲು ಮಾತ್ರ ಇದನ್ನು ಬಳಸಲಾಗುತ್ತದೆ.",
    "moving.list_women_only": "ಹೊಸದಾಗಿ ಬಂದ ಮಹಿಳೆಯರಿಗೆ ಮಾತ್ರ ಸಹಾಯ ಮಾಡುವಿರಾ?",
    "moving.list_slots": "ಒಮ್ಮೆಗೆ ಎಷ್ಟು ಹೊಸಬರು?",
    "moving.slots": "ಒಮ್ಮೆಗೆ {n}",
    "moving.done": "ಆಯಿತು",
    "moving.list_confirm": "ಹೊಸಬರು ಇದನ್ನು ನೋಡುತ್ತಾರೆ: {name}, {area}, {trades}, {langs} ಮಾತಾಡುತ್ತಾರೆ, ಒಮ್ಮೆಗೆ {slots}.",
    "moving.list_yes": "ನನ್ನನ್ನು ತೋರಿಸಿ",
    "moving.list_no": "ಈಗ ಬೇಡ",
    "moving.list_later": "ಸರಿ. ಸಹಾಯ ಮಾಡಬೇಕೆನಿಸಿದಾಗ ಮತ್ತೆ ಹೇಳಿ.",
    "moving.unlisted": "ನೀವು ಪಟ್ಟಿಯಿಂದ ಹೊರಗಿದ್ದೀರಿ. ಹೊಸಬರಿಗೆ ಇನ್ನು ನೀವು ಕಾಣುವುದಿಲ್ಲ.",
    "moving.not_listed": "ಹೊಸಬರಿಗೆ ಸಹಾಯ ಮಾಡುವವರ ಪಟ್ಟಿಯಲ್ಲಿ ನೀವು ಇಲ್ಲ.",
};
//# sourceMappingURL=moving.js.map